var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWallet1 = function SvgWallet1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.02.324c-8.286 0-15 6.715-15 15s6.714 15 15 15c8.285 0 15-6.715 15-15s-6.715-15-15-15Z",
    fill: "url(#wallet1_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.941 11.89h-.26c-1.782 0-3.564-.006-5.351 0-1.087.005-1.941.71-2.132 1.765-.027.149-.027.303-.027.456-.005.807-.005 1.618 0 2.424.006 1.331.907 2.228 2.238 2.228h5.527c.005.074.01.138.01.196 0 .631.006 1.257 0 1.888-.005.668-.392 1.055-1.066 1.055H6.786c-.673.011-1.071-.387-1.071-1.066V9.821c0-.68.392-1.077 1.071-1.077H21.88c.674 0 1.066.387 1.066 1.056.006.63 0 1.256 0 1.888.006.058 0 .116-.005.201Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.32 14.084c0-.54-.323-.87-.864-.875-2.037-.005-4.068-.005-6.105 0-.54 0-.859.329-.859.875v2.408c0 .658.297.955.96.955h2.944c1.018 0 2.041.005 3.06 0 .54 0 .864-.334.864-.87.006-.838.006-1.666 0-2.493Zm-5.738 2.175a.935.935 0 0 1-.918-.934.928.928 0 1 1 1.857.006.921.921 0 0 1-.94.928Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet1_svg__a",
    x1: 30.02,
    y1: 15.324,
    x2: 0.02,
    y2: 15.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#851A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70CCC"
  })))));
};

export default SvgWallet1;